import { render, staticRenderFns } from "./MobileAccessNotice.vue?vue&type=template&id=6004c403&scoped=true"
import script from "./MobileAccessNotice.vue?vue&type=script&lang=js"
export * from "./MobileAccessNotice.vue?vue&type=script&lang=js"
import style0 from "./MobileAccessNotice.vue?vue&type=style&index=0&id=6004c403&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6004c403",
  null
  
)

export default component.exports